'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherRefreshCw } from '@subframe/core';
import { Button, Dialog } from '@/shared/components/ui';
interface ErroPagamentoModalProps {
  descricao?: string | null;
  onTentarNovamente: () => void;
  onTrocarMetodo: () => void;
}
const DESCRICAO_PADRAO = 'Não foi possível processar o seu pagamento. Isso pode ter acontecido por saldo insuficiente, dados incorretos ou recusa do banco.';
export const ErroPagamentoModal = t0 => {
  const $ = _c(14);
  const {
    descricao,
    onTentarNovamente,
    onTrocarMetodo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-error-50 flex h-11 w-11 items-center justify-center rounded-[12px]"><FeatherAlertTriangle className="text-error-600" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-heading-dark text-base font-bold">Houve um problema com o pagamento</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = descricao || DESCRICAO_PADRAO;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="flex flex-col gap-1.5">{t2}<span className="text-label-muted text-sm leading-snug">{t3}</span></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherRefreshCw />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onTentarNovamente) {
    t6 = <Button size="small" className="w-full" iconRight={t5} onClick={onTentarNovamente}>Tentar novamente</Button>;
    $[5] = onTentarNovamente;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onTrocarMetodo) {
    t7 = <button type="button" onClick={onTrocarMetodo} className="text-brand-600 w-full text-center text-sm font-semibold underline">Usar outro método de pagamento</button>;
    $[7] = onTrocarMetodo;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-label-muted w-full text-center text-sm">Se o problema continuar,{" "}<a href="mailto:suporte@arbitralis.com.br" className="text-brand-600 font-semibold underline">entre em contato com o suporte</a></span>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
    t9 = <Dialog open={true} onOpenChange={_temp}><Dialog.Content className="w-[calc(100%-2rem)] max-w-[400px] gap-4 rounded-[16px] p-6">{t1}{t4}{t6}{t7}{t8}</Dialog.Content></Dialog>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
function _temp() {}